var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail16Px = function SvgEmail16Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4E6DF5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.666 2.667h10.667c.733 0 1.333.6 1.333 1.333v8c0 .733-.6 1.333-1.333 1.333H2.666c-.733 0-1.333-.6-1.333-1.333V4c0-.733.6-1.333 1.333-1.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.666 4 8 8.667 1.333 4"
  }))));
};
export default SvgEmail16Px;